export default "__VITE_ASSET__002eadb0__"